function SelectRouteControl(map, $location) {
  this.map = map;
  this.scope = map.scope;
  this.$location = $location;
}

SelectRouteControl.prototype.selectRoute = function(route) {
  this.scope.route = route;
  this.scope.map.route = route;

  this.updateRouteParam();

  Object.keys(this.map.pickupLocationLayers).forEach(function(pickupLocationId) {
    var visible = ! route || route.pickupLocationId === +pickupLocationId;
    this.map.pickupLocationLayers[pickupLocationId].layer.setVisible(visible);
  }, this);

  Object.keys(this.map.routeLayers).forEach(function(routeId) {
    var visible = ! route || route.id === +routeId;
    this.map.routeLayers[routeId].layer.setVisible(visible);
  }, this);

  Object.keys(this.map.carLayers || {}).forEach(function(routeId) {
    var visible = ! route || route.id === +routeId;
    this.map.carLayers[routeId].setVisible(visible);
  }, this);
};

SelectRouteControl.prototype.updateRouteParam = function() {
  var scopeRouteId = this.scope.route ? this.scope.route.id : null;
  var paramRouteId = +this.$location.search().routeId || null;

  if (scopeRouteId !== paramRouteId) {
    this.$location.search('routeId', scopeRouteId).replace();
  }

  this.$location.search('routeSequence', null).replace();  // Always reset / remove selected stop from QS

};

module.exports = SelectRouteControl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/selectRouteControl.js
 ** module id = 191
 ** module chunks = 1
 **/